
import { Users, FileText, MessageSquare, TrendingUp } from "lucide-react";
import { useLiveStats } from "@/hooks/use-live-stats";

const SocialProof = () => {
  const { stats, isLoading } = useLiveStats();

  // Don't show anything while loading
  if (isLoading) {
    return null;
  }

  // Set minimum baselines based on actual platform usage
  const activeCompanies = Math.max(stats.activeUsers, 31);
  const documentTypes = Math.max(stats.documentTypes, 100);
  const totalConversations = Math.max(stats.totalConversations, 100);

  // Hide the entire section until we reach 50 active companies
  if (activeCompanies < 50) {
    return null;
  }

  const liveStats = [
    {
      icon: Users,
      value: activeCompanies.toLocaleString(),
      label: "Active Companies",
      description: "Growing community of leaders"
    },
    {
      icon: FileText,
      value: `${documentTypes}+`,
      label: "Document Types",
      description: "Strategic plans, forecasts, and more"
    },
    {
      icon: MessageSquare,
      value: totalConversations.toLocaleString() + "+",
      label: "AI Conversations",
      description: "Strategic insights delivered daily"
    },
    {
      icon: TrendingUp,
      value: `+${stats.averageGrowthRate}%`,
      label: "Weekly Growth",
      description: "Platform momentum"
    }
  ];

  return (
    <section className="py-16 bg-white border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h3 className="text-lg font-semibold text-gray-600 mb-2">
            Trusted by forward-thinking businesses worldwide
          </h3>
          <p className="text-gray-500">
            Join the executives transforming their strategy with our complete C-Suite AI team
          </p>
          <p className="text-sm text-cso-600 font-medium mt-2">
            📊 Live data updated in real-time
          </p>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {liveStats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="flex justify-center mb-3">
                <div className="p-3 rounded-full bg-cso-50">
                  <stat.icon className="h-6 w-6 text-cso-600" />
                </div>
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-1">
                {stat.value}
              </div>
              <div className="text-sm font-medium text-gray-600 mb-1">
                {stat.label}
              </div>
              <div className="text-xs text-gray-500">
                {stat.description}
              </div>
            </div>
          ))}
        </div>

        {stats.totalDocuments > 0 && (
          <div className="text-center mt-8">
            <p className="text-sm text-gray-500">
              <span className="font-semibold text-cso-600">{Math.max(stats.totalDocuments, 100).toLocaleString()}</span> strategic documents created and counting
            </p>
          </div>
        )}
      </div>
    </section>
  );
};

export default SocialProof;
